import React, { useEffect, useState } from "react";
import styles from "./NearestShop.style";
import Section from "../Section/Section";
import { Col, Container, Row, Card, Image, Spinner } from "react-bootstrap";
import Heading from "../Heading/Heading";
import bookmark from "../../assets/images/bookmark.png";
import shop1 from "../../assets/images/default-shop.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Nearest_Shops } from "../../Api";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/Store";
import { FaStar } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { base_url } from "../../Api/ApiConst";
import { useTranslation } from "react-i18next";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { SET_SELECTED_STORE_SUBCATEGORY } from "../../Redux/User";
import lottieNearByShop from "../../assets/lotties/nearByShops.json";
import { Player } from "@lottiefiles/react-lottie-player";
import NoDataFound from "../NoDataFound/NoDataFound";
import moment from "moment";
import { getImageUrl } from "../../Utils/imageUtils";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1901 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1900, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
  },
};

interface Category {
  id: string;
  store_name: string;
  store_type: string;
  distance_in_km: string;
  language_data: any;
  store_rating: any;
  logo: string;
  opening_time: string;
  closing_time: string;
}

const NearestShop: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(true);
  const selectedCatgeory: any = useSelector(
    (state: RootState) => state.mainCategory.selectedMainCategory
  );
  const [stores, setStores] = React.useState<Category[]>([]);
  const languageId: any = useSelector((state: RootState) => state.lan);
  const navigate = useNavigate();
  const userLatitude = useSelector(
    (state: RootState) => state.Location.selected_latitude
  );
  const userLongitude = useSelector(
    (state: RootState) => state.Location.selected_longitude
  );
  const dispatch = useDispatch();
  const userPincode = useSelector((state: RootState) => state.Location.pincode);
  const fetchShops = async () => {
    try {
      const payload = {
        business_type: selectedCatgeory?.name,
        lat: userLatitude,
        long: userLongitude,
        pincode: userPincode,
      };
      const response = await Nearest_Shops(payload);
      if (response && response.status === 200) {
        setStores(response.data.store_list);
      } else {
        console.log("Error fetching Nearest Shops");
      }
    } catch (error) {
      console.log("Error fetching Nearest Shops", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCatgeory?.name && userLatitude && userLongitude) {
      fetchShops();
    }
  }, [selectedCatgeory?.name, userLatitude, userLongitude]);

  const handleClick = (item: any) => {
    localStorage.setItem(STORAGE_CONSTANTS.SHOP_ID, item?.id);
    dispatch(SET_SELECTED_STORE_SUBCATEGORY({}));
    let languageData = undefined;
    if (item?.language_data && item?.language_data.length > 0) {
      languageData = item?.language_data[0].store_name;
    }
    const state = {
      store_name: item?.store_name,
      store_type: item?.store_type,
      distance_in_km: item?.distance_in_km,
      language_data: languageData,
      store_rating: item?.store_rating,
      store_logo: item?.logo,
      storeId: item?.id,
    };
    navigate("/store", { state: state });
  };

  return (
    <>
      <Section className="near mb-5">
        <Container>
          <Row className="inner-wrap">
            <Col className="align-items-center justify-content-between d-flex">
              <Heading
                text={t("homeScreen.titleSectionNearestShop")}
                alignment="left"
              />
              {!loading && stores.length >= 3 && (
                <Link style={styles.viewAll} to="/near-by-shops">
                  {t("commonHeader.viewAll")}
                </Link>
              )}
            </Col>
          </Row>
          {loading && (
            <Row>
              <Col className="d-flex align-items-center justify-content-center">
                <Player
                  src={lottieNearByShop}
                  loop
                  autoplay
                  className="player"
                  style={{ height: "150px", width: "150px" }}
                />
              </Col>
            </Row>
          )}
          {!loading && stores.length === 0 && (
            <NoDataFound title={t("commonHeader.noShopsFoundInYourArea")} />
          )}
          {!loading && stores.length !== 0 && (
            <Row>
              <Col>
                <Carousel
                  swipeable={false}
                  draggable={false}
                  showDots={false}
                  responsive={responsive}
                  ssr={true}
                  infinite={false}
                  autoPlaySpeed={1000}
                  keyBoardControl={true}
                  customTransition="all .5"
                  transitionDuration={500}
                  containerClass="carousel-container"
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px"
                >
                  {stores &&
                    stores.map((item) => {
                      const now = moment();
                      const openingTime = moment(item.opening_time, "HH:mm:ss");
                      const closingTime = moment(item.closing_time, "HH:mm:ss");
                      const isOpen = now.isBetween(
                        openingTime,
                        closingTime,
                        null,
                        "[]"
                      );

                      return (
                        <div
                          className={`d-flex align-items-center singleShop ${
                            !isOpen ? "grayed-out" : ""
                          }`}
                          style={
                            styles.singleShopWrap 
                          }
                          key={item.id}
                          onClick={() => handleClick(item)} // Disable click if closed
                        >
                          <div
                            style={styles.shopImageWrap}
                            className="shopImgWrap"
                          >
                            {item.logo ? (
                              <Image
                                src={getImageUrl(item.logo)}
                                style={styles.shopImage}
                              />
                            ) : (
                              <Image src={shop1} style={styles.shopImage} />
                            )}
                          </div>
                          <div className="px-2 shopInfo">
                            <h2
                              style={{
                                ...styles.shopName,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              className="mb-1 shopName"
                            >
                              {item?.language_data?.length > 0
                                ? languageId === "ne"
                                  ? item?.language_data[0]?.store_name
                                  : item?.store_name
                                : item?.store_name}
                            </h2>
                            <div className="d-flex align-items-center mb-3 loc-wrap">
                              <p
                                className="mb-0 d-flex"
                                style={styles.shopRating}
                              >
                                <FaStar className="m-1" />
                                {Math.round(item?.store_rating)}
                              </p>
                            </div>
                            <div className="d-flex align-items-center mb-1 dist-supply">
                              <h3 style={styles.shopDistance} className="mb-0">
                                {item?.distance_in_km}Km
                              </h3>
                              <div
                                className="supply-wrap"
                                style={{
                                  ...styles.bookmarkBg,
                                  backgroundImage: `url(${bookmark})`,
                                }}
                              >
                                <p className="mb-0" style={styles.supplyMethod}>
                                  {item?.language_data?.length > 0
                                    ? languageId === "ne"
                                      ? item?.language_data[0]?.store_type
                                      : item?.store_type === "ONLY_PICK_UP" ? "Only Pick Up" : item?.store_type === "ONLY_DELIVERY" ? "Only Delivery" : "Pick and Delivery"
                                    : item?.store_type}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Carousel>
              </Col>
            </Row>
          )}
        </Container>
      </Section>
    </>
  );
};

export default NearestShop;
